/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const locales = ['en'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
 // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
 // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: "Women's Job Center",
    SITE_DESCRIPTION: 'Employers using WomensJobCenter.com can showcase their commitment to gender diversity and inclusion. Attracting a broad pool of applicants who identify as female',
    SHARING_BUTTONS_ENABLED: ['facebook', 'linkedin', 'email', 'twitter', 'whatsapp'],
    SOCIAL_LINKS: {
      linkedin: 'https://www.linkedin.com/company/workplacediversitycom',
    },
    PRICE_CONFIG: {
      CURRENCY_PLACEMENT: 'before',
      USE_SPACING: false,
    },
    SUBSCRIPTIONS_FEATURE_ACTIVE: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    SHOW_GA4_STATISTICS: false,
    ASSETS: {
      logo: '/static/womensjobcenter/logo.svg',
      faviconsPath: '/static/womensjobcenter',
    },
    OG_IMAGE: '/static/womensjobcenter/og-image.jpg',
    THEME: {
      colors: {
        primary: '#6C2295',
      },
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      location: { lat: 39.810106, lng: -98.557822 },
      radius: 500,
    },
    GA4_MEASUREMENT_IDS: ['G-CBJP8JE7MS', 'G-MY7B50XY97'],
    GOOGLE_MEASUREMENT_API_ENABLED: true,
    PRIVACY_LINK: 'https://www.womensjobcenter.com/privacy-policy',
    EURO_VAT_SYSTEM: false,
  },
});
